﻿// Copyright (c) 2012 Florian H., https://github.com/js-coder https://github.com/js-coder/lostorage.js
!function (window, undefined) {

    var utils = {

        isArray: Array.isArray || function (value) {
            return Object.prototype.toString.call(value) === '[object Array]';
        },

        isPlainObj: function (value) {
            return value === Object(value);
        },

        toArray: function (value) {
            return Array.prototype.slice.call(value);
        },

        // Convert arguments to an Array (`utils.toArray`) and prepend `element`.
        prepareArgs: function (args, element) {
            args = utils.toArray(args);
            args.unshift(element);
            return args;
        },

        getObjKeyByValue: function (obj, value) {
            for (var key in obj) {
                if (obj.hasOwnProperty(key)) {
                    if (obj[key] === value) return key;
                }
            }
        },

        // Prepares the return value to enable chaining.
        prepareReturn: function (type) {
            return window[utils.getObjKeyByValue(types, type)];
        },

        retrieve: function (value, fallback) { // Returns fallback if the value is undefined, otherwise value.
            return value == undefined ? fallback : value;
        },

        serialize: function (data) {
            return JSON.stringify(data);
        },

        unserialize: function (data) {
            if (data == undefined) return undefined;
            return JSON.parse(data);
        }

    };

    var _storage = function () {
        return _storage.get.apply(this, arguments);
    };

    var host = {
        storage: function () {
            return storage.get.apply(storage, arguments);
        },
        session: function () {
            return session.get.apply(session, arguments);
        }
    };

    _storage.set = function (type, key, value) {

        if (utils.isPlainObj(key)) {

            for (var k in key) {
                if (key.hasOwnProperty(k)) type.setItem(k, utils.serialize(key[k]));
            }

        } else type.setItem(key, utils.serialize(value));

        return utils.prepareReturn(type); // to enable chaining

    };

    _storage.invert = function (type, key) {
        return this.set(type, key, !(this.get(type, key)));
    };

    _storage.add = function (type, key, value) {
        return this.set(type, key, this.get(type, key) + parseInt(value, 10));
    };

    _storage.increase = function (type, key, value) {
        return this.add(type, key, utils.retrieve(value, 1));
    };

    _storage.decrease = function (type, key, value) {
        return this.add(type, key, -utils.retrieve(value, 1));
    };

    _storage.concat = function (type, key, string) { // append?
        return this.set(type, key, this.get(type, key) + string);
    };

    _storage.push = function (type, key, value) {

        var args = utils.toArray(arguments),
             arr = this.get(type, key, []);

        args.splice(0, 2);
        arr.push.apply(arr, args);

        return this.set(type, key, arr);

    }

    _storage.extend = function (type, key, k, v) { // variables?

        var value = this.get(type, key, {});

        if (utils.isPlainObj(k)) {

            for (var _k in k) {
                if (k.hasOwnProperty(_k)) value[_k] = k[_k];
            }

        } else value[k] = v;

        return this.set(type, key, value);

    };

    _storage.remove = function (type, keys) {

        keys = utils.isArray(keys) ? keys : utils.toArray(arguments);

        for (var i = 0, l = keys.length; i < l; i++) {
            delete type[keys[i]];
        }

        return utils.prepareReturn(type);

    };

    _storage.empty = function (type) {

        type.clear();

        return utils.prepareReturn(type);

    };

    _storage.get = function (type, keys, fallback) {

        fallback = fallback || undefined;

        if (utils.isArray(keys)) {
            var result = {};

            for (var i = 0, l = keys.length; i < l; i++) {
                var key = keys[i];
                result[key] = this.get(type, key, fallback);
            }

            return result;
        } else return utils.retrieve(utils.unserialize(type.getItem(keys)), fallback);

    };

    _storage.all = function (type) {

        var obj = {};

        for (var i = 0, l = type.length; i < l; i++) {
            var key = type.key(i);
            obj[key] = utils.unserialize(type.getItem(key));
        }

        return obj;
    };

    var methods = 'set invert add increase decrease concat push extend remove empty get all'.split(' '); // Methods of _storage that need to be copied to storage and session.

    var types = {
        storage: localStorage,
        session: sessionStorage
    };

    for (var i = 0, l = methods.length; i < l; i++) {

        var method = methods[i];

        for (var name in types) {

            if (!(types.hasOwnProperty(name))) continue;

            var storeType = types[name];

            host[name][method] = function (method, storeType) {
                return function () {
                    var args = utils.prepareArgs(arguments, storeType);
                    return _storage[method].apply(_storage, args);
                };
            }(method, storeType);

        }

    }

    // loStorage object for AMD & CommonJS.
    var loStorage = {
        storage: host.storage,
        session: host.session
    };

    // AMD, CommonJS or global.
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return loStorage;
        });
    } else if (typeof exports !== 'undefined') {
        module.exports = loStorage;
    } else {
        window.storage = host.storage;
        window.session = host.session;
    }

}(window);
;
////#region Global Methods
//// <reference path="idstc.js" />
//$.ajaxSetup({
//    error: function (event, jqXHR, ajaxSettings, thrownError) {
//        // this callback called always on all ajax request errors
//        $(document).progressFinish();
//    }
//});

var idstcBaseSiteDataLoaded = false;
var g_bProgressWatch = false;

(function () {

    if (typeof window.CustomEvent === 'function') return false;

    function CustomEvent(event, params) {
        params = params || { bubbles: false, cancelable: false, detail: undefined };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    CustomEvent.prototype = window.Event.prototype;

    window.CustomEvent = CustomEvent;
})();

// Polyfill for "startsWith" for Internet Explorer
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        position = position || 0;
        return this.indexOf(searchString, position) === position;
    };
}

if (!Array.prototype.findIndex) {
    Array.prototype.findIndex = function (predicate) {
        'use strict';
        if (this == null) {
            throw new TypeError('Array.prototype.findIndex called on null or undefined');
        }
        if (typeof predicate !== 'function') {
            throw new TypeError('predicate must be a function');
        }
        var list = Object(this);
        var length = list.length >>> 0;
        var thisArg = arguments[1];
        var value;

        for (var i = 0; i < length; i++) {
            value = list[i];
            if (predicate.call(thisArg, value, i, list)) {
                return i;
            }
        }
        return -1;
    };
}

$(function () {
    //window.onerror = function (errorMsg, url, line, column, exception) {
    //    JL().fatalException({
    //        'msg': 'Exception!',
    //        'errorMsg': errorMsg,
    //        'url': url,
    //        'line number': line,
    //        'column': column
    //    }, exception);
    //}

    // Custom event fired on button clicks throughout the system for disabling buttons.
    window.addEventListener('progressStart', function (e) {
        // Set global watch var
        g_bProgressWatch = true;

        // Disable any buttons with custom attr (should always only be one button, .each is a catchall)
        $('button[ngclick-evt="evtCurr"]').each(function () {
            $(this).prop('disabled', 'true');
        });

        var evt = new CustomEvent('progressWatch', { detail: 'true' });
        window.dispatchEvent(evt);
    });

    // Watch event for automatic firing of progress finish event.  Will forcibly call event if not fired after interval.
    window.addEventListener('progressWatch', function (e) {
        var started = Date.now();

        // Loop every 100 ms
        var interval = setInterval(function () {

            // Allow main loop to proceed for 15000ms
            if (Date.now() - started > 15000) {

                var evt = new CustomEvent('progressFinished', { detail: 'true' });
                window.dispatchEvent(evt);

                // Stop main propagation
                clearInterval(interval);
            } else {
                if (g_bProgressWatch) {
                    // Do nothing
                } else {
                    // Progress finished correctly.
                    clearInterval(interval);
                    return;
                }
            }
        }, 100);
    });

    // Custom event fired on progress finish event, for re-enabling buttons.
    window.addEventListener('progressFinished', function (e) {
        g_bProgressWatch = false;

        // Potentially re-enable any buttons with custom attr (should always only be one button, .each is a catchall)
        $('button[ngclick-evt="evtCurr"]').each(function () {
            if ($(this).attr('id') != null) {
                if (document.getElementById($(this).attr('id')).getAttribute('disabled') == 'disabled') {
                    // do nothing since angular disabled this
                } else {
                    $(this).prop('disabled', false);
                }
            }
        });

        // Remove custom attr from any buttons with custom attr (should always only be one button, .each is a catchall)
        $('button[ngclick-evt="evtCurr"]').each(function () {
            $(this).removeAttr('ngclick-evt');
        });

        $('div[ngclick-evt="evtCurr"]').each(function () {
            $(this).removeAttr('ngclick-evt');
        });
    });
});


//#endregion

//#region  Global Functions / Properties that should probably either be moved into IDSTC object or to another location

var HideIDSTCNotifyTimeout;

function getCookie(cname) {
    var name = cname + '=';
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1);
        if (c.indexOf(name) === 0) return c.substring(name.length, c.length);
    }
    return '';
}

function getNotificationsArray() {
    var strNotifications = getCookie('notifications');

    if (strNotifications.length > 0) {
        return JSON.parse(strNotifications);
    }
    else {
        return [];
    }
}

function hideNotification(e, hideOnlyIfOld) {
    clearTimeout(HideIDSTCNotifyTimeout);

    var timestamp = $(e).data('timestamp');

    if (hideOnlyIfOld) {
        var diff = Math.abs(Date.now() - timestamp);
        if (diff < 5000) {
            return;
        }
    }

    $(e).closest('.k-notification').remove();

    var notifications = getNotificationsArray();
    var index = notifications.indexOf(notifications.filter(function (item) {
        return item.timestamp === timestamp;
    })[0]);

    if (index != null && index >= 0) {
        notifications.splice(index, 1);
        document.cookie = 'notifications=' + JSON.stringify(notifications) + '; path=/';

        if (notifications.length === 0) {
            $('#sidebar-wrapper', window.parent.document).removeClass('active');
            $('#notification').removeClass('flash');
        }
    }
}

function getNotificationDetails(e) {
    var notification = $(e).closest('.k-notification');
    alert(notification.find('p').text());
}

function GetMultiSelectOptionsWithData(Placeholder, TextField, ValueField, dataset) {
    var options = {
        placeholder: Placeholder,
        dataTextField: TextField,
        dataValueField: ValueField,
        autoBind: false,
        valuePrimitive: true,
        filter: 'contains',
        dataSource: {
            data: dataset
        }
    };

    return options;
}

function GetMultiSelectOptions(Placeholder, TextField, ValueField, Url) {
    var options = {
        placeholder: Placeholder,
        dataTextField: TextField,
        dataValueField: ValueField,
        autoBind: false,
        valuePrimitive: true,
        filter: 'contains',
        dataSource: {
            serverFiltering: false,
            transport: {
                read: {
                    url: Url
                }
            }
        }
    };

    return options;
}

function GetAllMonths() {
    var january = idstc().translate('general', 'January', 'January');
    var february = idstc().translate('general', 'February', 'February');
    var march = idstc().translate('general', 'March', 'March');
    var april = idstc().translate('general', 'April', 'April');
    var may = idstc().translate('general', 'May', 'May');
    var june = idstc().translate('general', 'June', 'June');
    var july = idstc().translate('general', 'July', 'July');
    var august = idstc().translate('general', 'August', 'August');
    var september = idstc().translate('general', 'September', 'September');
    var october = idstc().translate('general', 'October', 'October');
    var november = idstc().translate('general', 'November', 'November');
    var december = idstc().translate('general', 'December', 'December');

    return [
        { Text: january, Value: 1 },
        { Text: february, Value: 2 },
        { Text: march, Value: 3 },
        { Text: april, Value: 4 },
        { Text: may, Value: 5 },
        { Text: june, Value: 6 },
        { Text: july, Value: 7 },
        { Text: august, Value: 8 },
        { Text: september, Value: 9 },
        { Text: october, Value: 10 },
        { Text: november, Value: 11 },
        { Text: december, Value: 12 }
    ];
}

function GetMultiSelectMonthOptions(Placeholder, TextField, ValueField) {
    var months = GetAllMonths();

    var options = {
        placeholder: Placeholder,
        dataTextField: TextField,
        dataValueField: ValueField,
        autoBind: false,
        valuePrimitive: true,
        dataSource: months
    };

    return options;
}

function GetMultiSelectYesNoOptions(Placeholder, TextField, ValueField) {
    var yes = idstc().translate('general', 'Yes', 'Yes');
    var no = idstc().translate('general', 'No', 'No');

    var options = {
        placeholder: Placeholder,
        dataTextField: TextField,
        dataValueField: ValueField,
        autoBind: false,
        valuePrimitive: true,
        dataSource: [
            { Text: yes, Value: true },
            { Text: no, Value: false }
        ]
    };

    return options;
}

function GetMultiSelectYesNoNeitherOptions(Placeholder, TextField, ValueField) {
    var neither = idstc().translate('general', 'Neither', 'Neither');
    var options = GetMultiSelectYesNoOptions(Placeholder, TextField, ValueField);

    options.dataSource.push({ Text: neither, Value: null });

    return options;
}

function ConvertArrayColumnsToDate(colNameArray, dataArray) {
    var regex = /\/Date\(.*\)\//;

    if (colNameArray && colNameArray.length > 0) {
        dataArray.forEach(function (data) {
            colNameArray.forEach(function (colName) {
                if (data[colName] != null) {
                    if (regex.test(data[colName])) {
                        data[colName] = new Date(parseInt(data[colName].substr(6)));
                    }
                    else {
                        data[colName] = new Date(data[colName]);
                    }

                }
            });
        });

    }
}

//#endregion

//#region Global on load stuff ( Load notifications from cookie (if any), attach events, etc.
$(function () {
    var notifications = getNotificationsArray();

    $.each(notifications, function () {
        if ($('div[data-timestamp="' + this.timestamp + '"]').length === 0) {
            idstc().notify(
                { message: this.message, success: this.type, fromCookie: true, timestamp: this.timestamp },
                null
            );

            $('.loader').hide();
        }
    });
});
//#endregion

//#region Instantiate the idstc object --  requires dependency to jquery
var idstc = function (container) {
    // if a container is specified return that object or window if none specified.
    if (container) {

        if (window === this) {
            return new idstc(container);
        }

        this.el = $(container);
        return this;

    }
    else {
        // return window object if no identifier specified.

        return new idstc(window);
    }
};
//#endregion

//#region Notification Templates
idstc.templates = function (type, o) {
    var template = '';
    if (type === 'successerrorwarn') {
        //#region Success/Error/Warn Template
        template = "<div class='row notify-row notify-wrapper-#= type #'>" +
            "<div class='col-md-2 col-xs-2 notify text-center' onclick='getNotificationDetails(this);'>" +
            "<i class='fa fa-warning mega'></i>" +
            "</div>" +
            "<div class='col-md-10 col-xs-10 dark'>" +
            "<div class='col-md-11 col-xs-11 half-pad-top no-pad-right no-pad-left'>" +
            "<p class='notification-text'>#= message #</p>" +
            "</div>" +
            "<div class='col-md-1 col-xs-1 no-pad-right half-pad-top no-pad-left'>" +
            "<div data-timestamp='#= timestamp #' onclick='hideNotification(this);' class='pull-right mega mega-x'>" +
            "<i class='glyphicon glyphicon-remove'></i>" +
            "</div>" +
            "</div>" +
            "<div class='clearfix'></div>" +
            "<div class='row'>" +
            "<p class='text-right half-pad-right time'>#= age # minutes</p>" +
            "</div>" +
            "</div>" +
            "</div>";
        //#endregion
    }
    else if (type === 'confirm') {
        template = "<div id='confirm-dialog'>" +
            "<p class='confirm-message'>" + o.message + "</p>" +
            "<div class='padding'></div>" +
            "<div class='confirm-actions'>" +
            "<button class='pull-left btn btn-" + (o.cancelBtnClass ? o.cancelBtnClass : "warning") + " btncancel'><i class='fa fa-times-circle' aria-hidden='true'></i> " + (o.cancelText ? o.cancelText : idstc().translate('general', 'Cancel', 'Cancel')) + "</button>" +
            "<button class='pull-right btn btn-" + (o.continueBtnClass ? o.continueBtnClass : "primary") + " btnconfirm'><i class='fa fa-check-circle' aria-hidden='true'></i> " + (o.continueText ? o.continueText : idstc().translate('general', 'Continue', 'Continue')) + "</button>" +
            "</div>" +
            "</div>";
    }
    else if (type === 'confirmandresponse') {
        template = "<div id='confirm-dialog'>" +
            "<p class='confirm-message'>" + o.message + "</p>" +
            "<textarea placeholder='" + (o.placeHolder ? o.placeHolder : idstc().translate('general', 'DialogResponsePlaceholder', 'Reason for this action.')) + "' class='form-control confirmandresponse-textarea'></textarea>" +
            "<div class='padding'></div>" +
            "<div class='confirm-actions'>" +
            "<button class='pull-left btn btn-" + (o.cancelBtnClass ? o.cancelBtnClass : "warning") + " btncancel'><i class='fa fa-times-circle' aria-hidden='true'></i> " + (o.cancelText ? o.cancelText : idstc().translate('general', 'Cancel', 'Cancel')) + "</button>" +
            "<button class='pull-right btn btn-" + (o.continueBtnClass ? o.continueBtnClass : "primary") + " btnconfirm'><i class='fa fa-check-circle' aria-hidden='true'></i> " + (o.continueText ? o.continueText : idstc().translate('general', 'Continue', 'Continue')) + "</button>" +
            "</div>" +
            "</div>";
    }
    else if (type === 'confirmandresponseinput') {
        template = "<div id='confirm-dialog'>" +
            "<p class='confirm-message'>" + o.message + "</p>" +
            "<input type='text' id='responseinput' name='responseinput' placeholder='" + (o.placeHolder ? o.placeHolder : idstc().translate('general', 'DialogResponsePlaceholder', 'Reason for this action.')) + "' class='form-control confirmandresponse-input'></input>" +
            "<div class='padding'></div>" +
            "<div class='confirm-actions'>" +
            "<button class='pull-left btn btn-" + (o.cancelBtnClass ? o.cancelBtnClass : "warning") + " btncancel'><i class='fa fa-times-circle' aria-hidden='true'></i> " + (o.cancelText ? o.cancelText : idstc().translate('general', 'Cancel', 'Cancel')) + "</button>" +
            "<button class='pull-right btn btn-" + (o.continueBtnClass ? o.continueBtnClass : "primary") + " btnconfirm'><i class='fa fa-check-circle' aria-hidden='true'></i> " + (o.continueText ? o.continueText : idstc().translate('general', 'Continue', 'Continue')) + "</button>" +
            "</div>" +
            "</div>";
    }
    else if (type === 'alert') {
        template = "<div id='confirm-dialog'><p class='confirm-message'>" + o.message + "</p>" +
            "<div class='padding'></div>" +
            "<div class='confirm-actions center'>" +
            "<button class='center btn btn-primary btncancel'>" + idstc().translate('general', 'Continue', 'Continue') + "</button>" +
            "</div>" +
            "</div > ";
    }

    return template;
};
//#endregion

idstc.prototype = function () {
    var validation = {};

    var removeAllNotifications = function () {
        jQuery.each($('.k-notification'), function (i, val) {
            hideNotification(val);
        });

        document.cookie = 'notifications=; path=/';
    }

    var getURLParam = function (name) {
        var url = window.location.href;
        var results = new RegExp('[\\?&]' + name + '=([^&#]*)', 'i').exec(url);

        if (!results) {
            return null;
        }
        return results[1] || undefined;
    }
    // Changes made to make this search be case insensative.
    var translate = function (container, prop, defaultText) {
        let trans = sessionStorage.getItem('allTranslations');

        if (trans != null && typeof trans !== 'undefined' && trans != 'undefined') {
            var translations = JSON.parse(trans);

            if (translations != null) {
                if (translations[container] != null) {
                    if (translations[container][prop] != null) {
                        return translations[container][prop];
                    }
                    else {
                        prop = prop.toLowerCase();
                        if (translations[container][prop] != null) {
                            return translations[container][prop];
                        }
                    }
                }
            }
        }

        return defaultText;
    }

    var needCachedDataFromServer = function (dataType) {
        var storageData = localStorage.getItem(dataType);

        if (storageData == null) {
            return true;

        }

        storageData = JSON.parse(storageData);

        var diffTime = new Date().getTime() - storageData.dateTime;
        var diffInMinutes = Math.floor(diffTime / 1000 / 60); //get minutes from time

        if (diffInMinutes >= 30) { //cache for 30 minutes
            return true;
        };

        return false;
    }

    var setCachedDataFromServer = function (dataType, dataName, data) {
        let valueToSave = {
            dateTime: new Date().getTime()  //set timestamp for cache
        };

        valueToSave[dataName] = data;

        storage.set(dataType, valueToSave);
    }

    var getBaseSiteData = function () {
        let dto = {};

        dto.needAvailableUIElements = needCachedDataFromServer('AvailableUIElements');
        dto.needCurrencyTypes = needCachedDataFromServer('CurrencyTypes');
        dto.needTimeFormat = needCachedDataFromServer('TimeFormat');
        dto.needUTCOffset = needCachedDataFromServer('UTCOffset');
        dto.needCulture = (needCachedDataFromServer('Culture') || needCachedDataFromServer('DateFormat'));
        dto.needTranslations = (sessionStorage.getItem('allTranslations') == null);
        dto.needMenuItems = (sessionStorage.getItem('menuItems') == null);
        dto.needHelpTexts = (sessionStorage.getItem('helpTexts') == null);
        dto.needPermissions = (sessionStorage.getItem('flightPermissions') == null);
        dto.needDefaultShoppingCartLayout = (sessionStorage.getItem('defaultShoppingCartLayout') == null);

        if (dto.needAvailableUIElements ||
            dto.needCulture ||
            dto.needCurrencyTypes ||
            dto.needMenuItems ||
            dto.needTimeFormat ||
            dto.needTranslations ||
            dto.needUTCOffset ||
            dto.needHelpTexts ||
            dto.needPermissions ||
            dto.needDefaultShoppingCartLayout) {

            $.getJSON('/SecurityManagement/GetBaseSiteDataFlight', dto).done(
                function (resp) {
                    if (dto.needAvailableUIElements) {
                        setCachedDataFromServer('AvailableUIElements', 'availableElements', resp.AvailableUIElements)
                    }
                    if (dto.needCulture) {
                        setCachedDataFromServer('Culture', 'culture', resp.Culture)
                        setCachedDataFromServer('DateFormat', 'dateFormat', resp.DateFormat)
                    }
                    if (dto.needCurrencyTypes) {
                        setCachedDataFromServer('CurrencyTypes', 'currencyTypes', resp.CurrencyTypes)
                    }
                    if (dto.needTimeFormat) {
                        setCachedDataFromServer('TimeFormat', 'timeFormat', resp.TimeFormat)
                    }
                    if (dto.needUTCOffset) {
                        setCachedDataFromServer('UTCOffset', 'offset', resp.UTCOffset)

                        var scope = (typeof angular !== 'undefined') ? angular.element($('.time-display')).scope() : null;

                        // clock gets its own lookup; the shared `scope` above targets .time-display, which the nav
                        // refresh removed, and is left alone so the translations broadcast below is unchanged
                        var clockScope = (typeof angular !== 'undefined') ? angular.element($('.time-chip-group')).scope() : null;

                        if (clockScope != null && clockScope.siteCtrl != null) {
                            clockScope.$apply(function () {
                                clockScope.siteCtrl.applyUTCOffset();
                            })
                        }
                    }
                    if (dto.needTranslations) {
                        sessionStorage.setItem('allTranslations', JSON.stringify(resp.Translations));

                        // dormant: `scope` is the dead .time-display lookup, so this broadcast has not fired since
                        // the nav refresh. Repairing that selector revives it, which is a deliberate call, not a typo.
                        if (typeof scope != 'undefined' && scope != null) {
                            scope.$broadcast("translations.updated", null);
                        }
                    }
                    if (dto.needCulture) {
                        setCulture(resp.Culture);
                    }
                    if (dto.needMenuItems) {
                        sessionStorage.setItem('menuItems', JSON.stringify(resp.MenuItems));

                        var scope = (typeof angular !== 'undefined') ? angular.element($('.nav-search-wrapper')).scope() : null;

                        if (typeof scope != 'undefined' && scope != null) {
                            scope.$apply(function () {
                                scope.menuCtrl.loadMenu();
                            })
                        }
                    }
                    if (dto.needHelpTexts) {
                        sessionStorage.setItem('helpTexts', JSON.stringify(resp.HelpTexts));
                    }
                    if (dto.needPermissions) {
                        sessionStorage.setItem('flightPermissions', JSON.stringify(resp.FlightPermissions));
                    }
                    if (dto.needDefaultShoppingCartLayout) {
                        sessionStorage.setItem('defaultShoppingCartLayout', JSON.stringify(resp.DefaultShoppingCartLayout));
                    }
                    idstcBaseSiteDataLoaded = true;
                });
        }
        else {
            idstcBaseSiteDataLoaded = true;
        }
    }

    var getTranslationsFromServer = function () {
        var translations = JSON.parse(localStorage.getItem('allTranslations'));

        if (sessionStorage.getItem('allTranslations') == null) {
            $.getJSON('/api/translation/GetAllTranslations').done(
                function (data) {

                });
        }
    };

    var getUserAvailableUIElements = function (force) {
        var permissions = storage.get('AvailableUIElements');

        if (permissions != null) {
            var diffTime = new Date().getTime() - permissions.dateTime;
            var diffInMinutes = Math.floor(diffTime / 1000 / 60); //get minutes from time

            if (diffInMinutes >= 30 && !force) { //cache for 30 minutes
                idstc().getUserAvailableUIElements(true);
            };

            if (storage.get('AvailableUIElements') == null || !permissions.dateTime || force) { //reset available ui elements
                idstc().getAndStoreUserAvailableUIElements();
            }
        }
        else {
            idstc().getAndStoreUserAvailableUIElements();
        }
    };

    var getAndStoreUserAvailableUIElements = function () {
        $.getJSON('/SecurityManagement/GetUserAvailableUIElements').done(
            function (d) {
                var valueToSave = {
                    availableElements: d.Value,
                    dateTime: new Date().getTime()  //set timestamp for cache
                };

                storage.set('AvailableUIElements', valueToSave);
            });
    }

    var setSecurityDisabledProp = function (elName, path) {
        var rtnValue = '';
        var uielementFound = false;

        if (path == null) {
            path = window.location.href.toString().split(window.location.host)[1];
        }

        if (storage.get('AvailableUIElements')) {
            var uielements = storage.get('AvailableUIElements').availableElements;

            for (var i = 0; i < uielements.length; i++) {
                var uielemArray = uielements[i].split('-');
                if ((path.toLowerCase().indexOf(uielemArray[0].toLowerCase()) >= 0) && (uielemArray[1].toLowerCase().indexOf(elName.toLowerCase()) >= 0)) {
                    uielementFound = true;
                    break;
                }
            }

            if (uielementFound == false) {
                rtnValue = 'disabled';
            }
        }

        return rtnValue;
    }

    var getCurrencyTypes = function (force) {
        var currencyTypes = storage.get('CurrencyTypes');

        if (currencyTypes != null) {
            var diffTime = new Date().getTime() - currencyTypes.dateTime;
            var diffInMinutes = Math.floor(diffTime / 1000 / 60); //get minutes from time

            if (diffInMinutes >= 30 && !force) { //cache for 30 minutes
                idstc().getCurrencyTypes(true);
            };

            if (storage.get('CurrencyTypes') == null || !currencyTypes.dateTime || force) { //reset currency types
                idstc().getAndStoreCurrencyTypes();
            }
        }
        else {
            idstc().getAndStoreCurrencyTypes();
        }
    }

    var getAndStoreCurrencyTypes = function () {
        $.getJSON('/api/CurrencyTypes/GetCurrencyTypes')
            .done(function (data) {
                var valueToSave = {
                    currencyTypes: data,
                    dateTime: new Date().getTime()  //set timestamp for cache
                };

                storage.set('CurrencyTypes', valueToSave);
            })
            .fail(function (data) {
                console.log('failure GetCurrencyTypes');
            });
    }

    var getCurrencyTypeSymbol = function (currencyTypeID) {
        if (storage.get('CurrencyTypes') && currencyTypeID) {

            var currencyTypes = storage.get('CurrencyTypes').currencyTypes;

            // get the currency type info that will be used to format the number
            var index = currencyTypes.indexOf(currencyTypes.filter(function (CurrencyType) {
                return CurrencyType.CurrencyTypeID == currencyTypeID;
            })[0]);

            if (index >= 0) {
                return currencyTypes[index].Symbol;
            }
            else {
                return '';
            }
        }
        else {
            return '';
        }
    }

    var getTimeFormat = function (force) {
        var TimeFormat = storage.get('TimeFormat');

        if (TimeFormat != null) { //permissions are in localstorage
            var diffTime = new Date().getTime() - TimeFormat.dateTime;
            var diffInMinutes = Math.floor(diffTime / 1000 / 60); //get minutes from time

            if (diffInMinutes >= 30 && !force) { //cache permissions for this user for 30 minutes
                idstc().getTimeFormat(true);
            };

            if (storage.get('TimeFormat') == null || !TimeFormat.dateTime || force) { //reset UTC offset
                idstc().getAndStoreTimeFormat();
            }
        }
        else { //currency types are not in localstorage
            idstc().getAndStoreTimeFormat();
        }
    }

    var getAndStoreTimeFormat = function () {
        $.getJSON('/api/DateTime/GetTimeFormat')
            .done(function (data) {
                var valueToSave = {
                    timeFormat: data,
                    dateTime: new Date().getTime()  //set timestamp for cache
                };

                storage.set('TimeFormat', valueToSave);
            })
            .fail(function () {
                console.log('failure GetTimeFormat');
            });
    }

    var getDateInCompanyTime = function (date, offset) {
        date.setHours(date.getHours() + offset);
        return date;
    }

    var getDateFormat = function (date, format, culture, isStatic) {
        if (typeof date === 'string' && date != '') {
            //microsoft's json serializer comes back with this weird date format sometimes.
            //http://stackoverflow.com/questions/206384/how-do-i-format-a-microsoft-json-date
            var regex = /\/Date\(.*\)\//;
            if (regex.test(date)) {
                date = new Date(parseInt(date.substr(6)));
            }
            else {
                date = new Date(date);
            }
        }

        if (isStatic && date != null) {
            var dateMoment = moment.utc(date);
            date = new Date(date.valueOf() + (date.getTimezoneOffset() * -1) * 60 * 1000);
        }

        format = format || 'd'; //set default to 'd' if no format passed in

        if (culture == null) {
            var cultureFromStorage = storage.get('Culture');

            if (cultureFromStorage != null) {
                culture = cultureFromStorage.culture;
            }
        }

        culture = culture || idstc().getCultureForLoggedInUser(); //set to culture for user if no culture passed in

        //get the culture script since we might have passed a culture we don't have a script for yet        
        return kendo.toString(date, format, culture);
    }

    var formatNumberToCurrency = function (number, currencyTypeID, excludeSymbol) {
        if (!isNaN(currencyTypeID) && typeof (currencyTypeID) !== 'number') {
            //we have a valid numeric value but its not of type numeric so convert it
            currencyTypeID = Number(currencyTypeID);
        }

        if (!currencyTypeID || isNaN(currencyTypeID)) {
            //fallback to usd if the currency type isn't is null or a bad parameter
            currencyTypeID = 1;
        }

        var formattedNumber = kendo.toString(number, 'c');

        var formattedNumber = String(number);

        if (storage.get('CurrencyTypes') && currencyTypeID) {

            var currencyTypes = storage.get('CurrencyTypes').currencyTypes;

            // get the currency type info that will be used to format the number
            var index = currencyTypes.indexOf(currencyTypes.filter(function (CurrencyType) {
                return CurrencyType.CurrencyTypeID == currencyTypeID;
            })[0]);

            if (index >= 0) {
                // Bug 17348: a plain space separator (CZK, NOK, EUR in CZ/SK/FR) lets the browser wrap
                // "5 118,50" across two lines, so emit a non-breaking space instead
                var separatorSymbol = currencyTypes[index].SeparatorSymbol.Symbol === ' ' ? '\u00A0' : currencyTypes[index].SeparatorSymbol.Symbol;

                // get the individual parts of the number passed in
                var numberArray = formattedNumber.split('.');

                var decimalValue = '';
                var numberValue = '';

                if (numberArray.length > 0) {
                    numberValue = numberArray[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, separatorSymbol);
                    if (numberArray.length > 1) {
                        decimalValue = (numberArray[1] + Array(currencyTypes[index].DecimalDigits.DecimalDigits).join('0')).substring(0, currencyTypes[index].DecimalDigits.DecimalDigits);
                    }
                    else {
                        //                              decimalValue = Array(currencyTypes[index].DecimalDigits.DecimalDigits).join('0');
                        decimalValue = (new Array(currencyTypes[index].DecimalDigits.DecimalDigits + 1)).join('0');
                    }
                }
                else {
                    numberValue = numberArray.toString().replace(/\B(?=(\d{3})+(?!\d))/g, separatorSymbol);
                    decimalValue = Array(currencyTypes[index].DecimalDigits.DecimalDigits).join('0');
                }

                formattedNumber = numberValue + currencyTypes[index].DecimalSymbol.Symbol + decimalValue;

                if (!excludeSymbol) {
                    if (currencyTypes[index].SymbolDisplayLocation.SymbolDisplayLocationID == 1) {
                        formattedNumber = currencyTypes[index].Symbol + formattedNumber;
                    }
                    else {
                        formattedNumber = formattedNumber + currencyTypes[index].Symbol;
                    }
                }
            }
        }

        return formattedNumber;
    }

    var getPhoneFormat = function (number, format) {
        if (!number) { return ''; }
        if (!format || format.length == 0) { format = '# (###) ###-####'; }

        number = String(number);
        var strippedNumber = number.replace(/\D/g, '');
        var formattedNumber = number;

        if (number == strippedNumber) {
            if (format == '### # ### ####' && number.length == 11) {
                formattedNumber = number.substr(0, 3) + ' ' + number.substr(3, 1) + ' ' + number.substr(4, 3) + ' ' + number.substr(7, 4);
            }
            if (format == '###-###-####' && number.length == 10) {
                formattedNumber = number.substr(0, 3) + '-' + number.substr(3, 3) + '-' + number.substr(6, 4);
            }
            if (format == '(###) ###-####' && number.length == 10) {
                formattedNumber = '(' + number.substr(0, 3) + ') ' + number.substr(3, 3) + '-' + number.substr(6, 4);
            }
            if (format == '### ### ####' && number.length == 10) {
                formattedNumber = number.substr(0, 3) + ' ' + number.substr(3, 3) + ' ' + number.substr(6, 4);
            }
            if (format == '###.###.####' && number.length == 10) {
                formattedNumber = number.substr(0, 3) + '.' + number.substr(3, 3) + '.' + number.substr(6, 4);
            }
            if (format == '# (###) ###-####') {
                var c = (number[0] === '1') ? '1 ' : '';
                number = number[0] === '1' ? number.slice(1) : number;

                // # (###) ###-#### as c (area) front-end
                var area = number.substring(0, 3);
                var front = number.substring(3, 6);
                var end = number.substring(6, 10);

                if (front) {
                    formattedNumber = (c + '(' + area + ') ' + front);
                }
                if (end) {
                    formattedNumber += ('-' + end);
                }
            }

            return formattedNumber;
        }

        return number;
    };

    /**
        Sets current culture. Will return kendo culture object.
    */
    var setCulture = function (cultureCode) {
        sessionStorage.setItem('culture', cultureCode);

        if (typeof kendo != 'undefined' && kendo != null) {
            kendo.culture(cultureCode);
        }

        // restamp body culture classes
        if (typeof window.applyCultureBodyClasses === 'function') {
            window.applyCultureBodyClasses();
        }
    };

    /**
    Gets the default language code
    */

    var getDefaultLanguageCode = function () {
        var culture = sessionStorage.getItem('culture');

        if (culture == null) {
            return $.get('/api/CountryProvinces/GetDefaultLanguageCodeNoUser?output=jsonp&callback=?', function (resultCode) {
                return resultCode;
            });
        }
        else {
            if (culture.length > 2) {
                return $.Deferred().resolve(culture.substring(0, 2)).promise();
            }
            else {
                return $.Deferred().resolve(culture).promise();
            }
        }

        return $.Deferred().resolve(culture).promise();
    };

    /**
        Sets up culture for the logged in user
    */
    var setupCultureForLoggedInUser = function () {

        getCultureForLoggedInUserAsync().then(function (culture) {
            setCulture(culture);
        });
    };

    var getUserCulture = function () {
        let cultureFromStorage = storage.get('Culture');

        if (cultureFromStorage != null) {
            return cultureFromStorage.culture;
        }
        else {
            return 'en-US';
        }
    }

    var getAfterpayLocaleInfo = function (countryCode, cultureCode) {
        var culture = cultureCode;
        if (!culture) {
            try {
                var cultureFromStorage = storage.get('Culture');
                if (cultureFromStorage != null && cultureFromStorage.culture) {
                    culture = cultureFromStorage.culture;
                }
            } catch (e) { }
        }
        if (!culture) {
            try {
                culture = sessionStorage.getItem('culture');
            } catch (e) { }
        }
        if (!culture) {
            culture = 'en-US';
        }
        culture = culture.replace(/_/g, '-');

        var languageCode = null;
        if (culture) {
            languageCode = (culture.length > 2 ? culture.substring(0, 2) : culture).toLowerCase();
        }

        var cc = countryCode;
        if (!cc && culture) {
            var parts = culture.split('-');
            if (parts.length > 1 && parts[1]) {
                cc = parts[1];
            }
        }
        cc = cc ? cc.toUpperCase() : null;

        var consumerLocale = null;
        var placementLocale = null;

        if (cc === 'CA') {
            consumerLocale = (languageCode === 'fr') ? 'fr-CA' : 'en-CA';
            placementLocale = (languageCode === 'fr') ? 'fr_CA' : 'en_CA';
        }
        else if (cc === 'US') {
            consumerLocale = 'en-US';
            placementLocale = 'en_US';
        }
        else if (cc === 'GB' || cc === 'UK') {
            consumerLocale = 'en-GB';
            placementLocale = 'en_GB';
        }
        else if (cc === 'NZ') {
            consumerLocale = 'en-NZ';
            placementLocale = 'en_NZ';
        }
        else if (cc === 'AU') {
            consumerLocale = 'en-AU';
            placementLocale = 'en_AU';
        }
        else if (cc && languageCode) {
            consumerLocale = languageCode + '-' + cc;
            placementLocale = languageCode + '_' + cc;
        }

        return {
            culture: culture,
            languageCode: languageCode,
            countryCode: cc,
            consumerLocale: consumerLocale,
            placementLocale: placementLocale
        };
    }

    var getCultureForLoggedInUserAsync = function () {
        var culture = sessionStorage.getItem('culture');

        if (culture == null) {
            return $.getJSON('/api/CountryProvinces/GetCultureForLoggedInUser')
                .done(function (resultCulture) {
                    return resultCulture;
                })
                .fail(function (error) {
                    console.log(error);
                    return 'en-US';
                });
        }

        return $.Deferred().resolve(culture).promise();
    };

    var getCultureForLoggedInUser = function () {
        var culture = sessionStorage.getItem('culture');

        if (culture == null) {
            return 'en-US';
        }

        return culture;
    };

    var processResponse = function (oArgs) {
        if (oArgs && oArgs.showNotifications) {
            if (oArgs.response.statusCode && oArgs.response.statusCode != 0) {
                if (oArgs.response.Notifications == null || oArgs.response.Notifications.length == 0) {
                    if (oArgs.response.valResults != null && oArgs.response.valResults.length > 0) {
                        oArgs.response.Notifications = [];

                        for (var i = 0; i < oArgs.response.valResults.length; i++) {
                            oArgs.response.messages.push({
                                Message: oArgs.response.valResults[i].ErrorMessage,
                                NotificationType: 1
                            });
                        }
                    }
                }

                idstc().notifyServerResponse(oArgs.response);

                return false;
            }
            else {
                idstc().notifyServerResponse(oArgs.response);
            }
        }

        return true;
    }

    var processError = function (oArgs) {
        // check for standard exception
        if (oArgs.error && oArgs.error.data && oArgs.error.data.ExceptionMessage && oArgs.showNotifications) {
            oArgs.response = {};
            oArgs.response.Notifications = [];
            oArgs.response.messages = [];

            oArgs.response.messages.push({
                Message: oArgs.error.data.ExceptionMessage,
                NotificationType: 1
            });

            idstc().notifyServerResponse(oArgs.response);
        }
        else if (oArgs.error && oArgs.error.data && oArgs.error.data.messages && oArgs.error.data.messages.length > 0 && oArgs.showNotifications) {
            oArgs.response = {};
            oArgs.response.Notifications = [];
            oArgs.response.messages = oArgs.error.data.messages;

            idstc().notifyServerResponse(oArgs.response);
        }
        else {
            // check for http exception
            if (oArgs.error && oArgs.error.status && oArgs.error.statusText && oArgs.showNotifications) {
                oArgs.response = {};
                oArgs.response.Notifications = [];
                oArgs.response.messages = [];

                oArgs.response.messages.push({
                    Message: oArgs.error.statusText,
                    NotificationType: 1
                });

                idstc().notifyServerResponse(oArgs.response);
            }
            else {
                if (oArgs.error && oArgs.error.messages) {
                    oArgs.response = {};
                    oArgs.response.Notifications = [];
                    oArgs.response.messages = [];

                    oArgs.response.messages = oArgs.error.messages;

                    idstc().notifyServerResponse(oArgs.response);
                }
                else {
                    idstc().notifyServerResponse(oArgs);
                }
            }
        }

    }

    // framework functions
    // *******************
    var responseMessage = function (messages, data, statusCode, success, valResults, origObj) {
        this.messages = messages;
        this.statusCode = statusCode;
        this.success = success || 'error';
        this.data = data;
        this.valResults = valResults;
        this.originalObject = origObj;

        return this;
    }

    //#region Notification Panel
    var toggleNotificationPanel = function (close, log, forceShow, o, showTimeMS) {
        var wp = window.parent.document;

        if (showTimeMS == null) {
            showTimeMS = 1750;
        }

        if (log) {
            console.log(log);
        }

        if (forceShow) {
            $('#sidebar-wrapper', wp).addClass('active');

            return true;
        }

        if (close) {
            clearTimeout(HideIDSTCNotifyTimeout);

            $('#sidebar-wrapper', wp).removeClass('active');

            return true;
        }
        else {
            clearTimeout(HideIDSTCNotifyTimeout);

            if (!o.fromCookie) {
                $('#sidebar-wrapper', wp).addClass('active');

                if (o && o.success.toLowerCase() === 'success') {
                    HideIDSTCNotifyTimeout = setTimeout(function () {
                        idstc().toggleNotificationPanel(true, null);
                        $('#notification').removeClass('flash');
                    }, showTimeMS);
                }
            }
        }
    }
    //#endregion

    //#region Common Dialog Helpers
    var notifyServerResponse = function (response, callback) {

        if (response && response.data && response.data.messages) {
            response = response.data;
        }

        if (response && response.data && response.data.ExceptionMessage) {
            response = response.data;
        }

        if (response && response.data && response.data.Notifications) {
            response = response.data;
        }

        if (response && response.data && response.data.responseJSON && response.data.responseJSON.Notifications) {
            response = response.data.responseJSON;
        }

        if (response && response.Notifications && response.messages == null) {
            //In case the return response hasn't been converted from server format; do it now
            var r = response;
            response = new idstc().responseMessage(r.Notifications, r.Value, r.ResultCode, 'success', r.ValidationResults);
        }

        if (response && response.messages) {
            $.each(response.messages, function () {
                var errortype;

                if (this.NotificationType === 0) {
                    errortype = 'success';
                }
                else if (this.NotificationType === 1) {
                    errortype = 'error';
                }
                else if (this.NotificationType === 2 || this.NotificationType === 3) {
                    errortype = 'warn';
                }

                // if (this.NotificationType != 3) {
                idstc().notify(
                    { message: this.Message, success: errortype },
                    callback
                );
                // }
            });
        }
        else {
            if (response) {
                if (response.ExceptionMessage) {
                    idstc().notify(
                        { message: response.ExceptionMessage, success: 'error' },
                        callback
                    );
                }
                else if ((response.status && response.status != 200) && response.statusText) {
                    idstc().notify(
                        { message: response.statusText, success: 'error' },
                        callback
                    );
                }
            }
        }
    }

    var notifyServerResponseHelp = function () {
        var help = {
            inputs: 'idstc ServerResponse object, callback()',
            requiredProperties: 'idstc serverreponse object',
            description: 'Call this method after using $http.get() and $http.post() methods. Get and Post return a client side ' +
                'server response object that may contain notifications. For each notification in the server response this method will display ' +
                'a notification as the corresponding type returned from the server. Success = 0, Warn =2, Error = 1'
        }

        console.log(help);
    }
    //#endregion

    //#region Common Dialog
    var notify = function (o, callback, showTimeMS) {
        o.type = 'notification';
        dialog(o, callback, showTimeMS);
    }

    var notifyHelp = function () {
        console.log('this method overloads dialog with a type of "notification". Run dialogHelp for detailed information.');
    }

    var dialog = function (o, callback, showTimeMS) {
        var wp = window.parent.document;

        if (!o.type) {
            o.type = 'confirm';
        }

        if (o.type.toLowerCase() === 'notification') {
            //#region Notification
            var n;

            if (!o.message) {
                return;
                //throw 'Supply a message property for notification';
            }

            if (!o.success) {
                return;
                //throw 'Supply a success property for notification';
            }

            if (o.success.toLowerCase() === 'success' || o.success.toLowerCase() === 'warn' || o.success.toLowerCase() === 'error' || o.success.toLowerCase() === 'alert') {

            } else throw 'Unacceptable success value from response. success, warn, error are supported.';

            if (o.template) {
                n = $('#notification-wrapper', wp).kendoNotification({
                    appendTo: $('#sidebar-wrapper', wp),
                    autoHideAfter: o.template.autoHideAfter,
                    stacking: o.template.stacking,
                    templates: o.template.templates,
                    button: true,
                    hideOnClick: false
                });
            }
            else {
                jQuery.each($('[data-timestamp]'), function (i, val) {
                    hideNotification(val, true);
                });

                var timestamp = o.timestamp || Date.now();

                n = $('#notification-wrapper', wp).kendoNotification({
                    appendTo: $('#sidebar-wrapper', wp),
                    autoHideAfter: 0,
                    stacking: 'up',
                    allowHideAfter: 5000,
                    button: true,
                    hideOnClick: false,
                    templates: [
                        {
                            type: 'successerrorwarn',
                            template: idstc.templates('successerrorwarn')
                        }
                    ]
                }).data('kendoNotification');

                if (!o.fromCookie) {
                    // Only add notification to cookie if it needs to be displayed on next page load
                    if (o.showNext) {
                        var notification = { message: o.message, type: o.success, timestamp: timestamp, showNext: o.showNext };
                        var notifications = getNotificationsArray();

                        notifications.push(notification);

                        document.cookie = 'notifications=' + JSON.stringify(notifications) + '; path=/';
                    }
                }

                if ($('div[data-timestamp="' + timestamp + '"]').length === 0) {
                    var diff = Math.abs(Date.now() - timestamp);

                    o.age = Math.floor((diff / 1000) / 60);

                    if (n) {
                        n.show(
                            {
                                type: o.success || '',
                                message: o.message || '',
                                age: o.age || '0',
                                timestamp: timestamp
                            },
                            'successerrorwarn'
                        );

                        idstc().toggleNotificationPanel(false, null, null, o, showTimeMS);

                        if (!o.fromCookie) {
                            $('#notification').addClass('flash');
                        }
                    }
                }

                //run callback
                if (callback && typeof (callback) === 'function') {
                    callback();
                }
            }
            //#endregion
        }
        else if (o.type.toLowerCase().indexOf('confirm') > -1) {
            //#region Confirm

            var winEl = $('#confirmDialog');
            var kendoWindow = winEl.kendoWindow({
                title: o.title,
                resizable: false,
                modal: true,
                actions: o.actions
            });

            if (o.type.toLowerCase() === 'confirm') {
                var kWindow = kendoWindow.data("kendoWindow");
                kWindow.wrapper.addClass("confirmWindow");
                kWindow.content(
                    idstc.templates('confirm', o)
                ).center().open();
            } else {
                if (o.type.toLowerCase() === 'confirmandresponse') {
                    var kWindow = kendoWindow.data("kendoWindow");
                    kWindow.wrapper.addClass("confirmResponseWindow");
                    kWindow.content(
                        idstc.templates('confirmandresponse', o)
                    ).center().open();
                }
                else {
                    var kWindow = kendoWindow.data("kendoWindow");
                    kWindow.wrapper.addClass("confirmResponseInputWindow");
                    kWindow.content(
                        idstc.templates('confirmandresponseinput', o)
                    ).center().open();
                }
            }

            if (!_.isNull(o.cancelButtonText) && !_.isUndefined(o.cancelButtonText)) {
                $('.confirm-actions > .btncancel').text(o.cancelButtonText);
            }

            if (!_.isNull(o.confirmButtonText) && !_.isUndefined(o.confirmButtonText)) {
                $('.confirm-actions > .btnconfirm').text(o.confirmButtonText);
            }

            $('.confirm-actions').on('click', '.btnconfirm', function () {
                //run whatever method was passed in on confirm
                if ($(this).hasClass('btnconfirm')) {
                    //run callback
                    if (callback && typeof (callback) === 'function') {
                        callback(true, $(this));
                    }

                }

                winEl.data('kendoWindow').close();

                return this;
            });

            $('.confirm-actions').on('click', '.btncancel', function () {

                winEl.data('kendoWindow').close();

                if (callback && typeof (callback) === 'function') {
                    callback(false, $(this));
                }

                return this;

            });
            //#endregion
        }
        else if (o.type.toLowerCase() === 'alert') {
            //#region Alert
            var winEl = $('#confirmDialog');

            var kendoWindow = winEl.kendoWindow({
                title: o.title,
                resizable: false,
                modal: true,
                actions: ['Close'],
                close: function () {
                    if (callback && typeof (callback) === 'function') {
                        callback(false, $(this));
                    }
                },
            });

            var kWindow = kendoWindow.data("kendoWindow");
            kWindow.wrapper.addClass("alertWindow");
            kWindow.content(
                idstc.templates('alert', o)
            ).center().open();

            $(".confirm-actions").on("click", ".btncancel", function () {

                winEl.data("kendoWindow").close();

                if (callback && typeof (callback) === "function") {
                    callback(false, $(this));
                }

                return this;

            });
            //#endregion
        }
        else {
            if (o.type) {
                throw 'incorrect dialog type specified. expecting confirm, or notification';
            }
            else {
                throw 'no dialog type specified.';
            }
        }

        return this;
    }

    var dialogHelp = function () {
        var help = {
            inputs: 'object{ type, success, message, title, kendoNotificationTemplate{}, continueText, cancelText, continueBtnClass, cancelBtnClass }',
            requiredProperties: 'success, message',
            defaults: "type = confirm, title = '', continueText = 'Continue', cancelText = 'Cancel', continueBtnClass = 'primary', cancelBtnClass = 'warn'",
            kendoTemplateDefault: {
                appendTo: '#notificationpanel',
                autoHideAfter: 4800,
                stacking: 'up',
                templates: [
                    {
                        type: 'successerrorwarn',
                        template: idstc.templates('successerrorwarn')
                    }
                ]
            },
            overrides: 'use notify which overrides dialog to a notification type.',
            notes: 'pass an anonymous fn() to run code after dialog'
        };

        console.log(help);
    }
    //#endregion

    var confirmDelete = function (data, callback) {

        idstc().dialog({ message: $('#deleteConfirmMessage').text() }, function (confirmed) {
            if (confirmed) {
                if (callback && typeof (callback) === 'function') {
                    callback(data);
                }
            }
        });
    }

    //#region Kendo Specific
    //this should be called from api callback
    var gridConfirmDelete = function (el, gridName, callback) {

        var uid = $(el).closest('tr').data('uid');
        var dataRow = $('#' + gridName).data('kendoGrid').dataSource.getByUid(uid);

        idstc(el).dialog({ message: $('#deleteConfirmMessage').text() }, function (confirmed) {
            if (confirmed) {
                if (callback && typeof (callback) === 'function') {
                    callback(dataRow);
                }
            }
            else {
                return false;
            }
        });
    }

    var gridConfirmDeleteHelp = function () {
        var help = {
            inputs: {
                element: '',
                gridName: '',
                anonFunction: '',
            },
            requiredProperties: 'element, gridName, anonFunction',
            defaults: 'none',
            overrides: '',
            notes: 'pass an anonymous fn() that handles any delete api calls and notification triggers.'
        };

        console.log(help);
    }
    //#endregion

    //#region Data Service

    var spinner = function () {

    }

    var spinnerClick = function () {

    }

    //#endregion

    //#region Dirty Form Handling

    var bindDirtyCheck = function (formid, callback) {
        $(formid).areYouSure({
            'silent': true,
        });
    }

    //#endregion

    //#region Method Returns
    return {
        validation: validation,
        removeAllNotifications: removeAllNotifications,
        getURLParam: getURLParam,
        translate: translate,
        getTranslationsFromServer: getTranslationsFromServer,
        notify: notify,
        notifyHelp: notifyHelp,
        dialog: dialog,
        dialogHelp: dialogHelp,
        confirmDelete: confirmDelete,
        gridConfirmDelete: gridConfirmDelete,
        gridConfirmDeleteHelp: gridConfirmDeleteHelp,
        processResponse: processResponse,
        processError: processError,
        responseMessage: responseMessage,
        toggleNotificationPanel: toggleNotificationPanel,
        bindDirtyCheck: bindDirtyCheck,
        notifyServerResponse: notifyServerResponse,
        notifyServerResponseHelp: notifyServerResponseHelp,
        getBaseSiteData: getBaseSiteData,
        getUserAvailableUIElements: getUserAvailableUIElements,
        getAndStoreUserAvailableUIElements: getAndStoreUserAvailableUIElements,
        setSecurityDisabledProp: setSecurityDisabledProp,
        getCurrencyTypes: getCurrencyTypes,
        getAndStoreCurrencyTypes: getAndStoreCurrencyTypes,
        getCurrencyTypeSymbol: getCurrencyTypeSymbol,
        getDateInCompanyTime: getDateInCompanyTime,
        formatNumberToCurrency: formatNumberToCurrency,
        getTimeFormat: getTimeFormat,
        getAndStoreTimeFormat: getAndStoreTimeFormat,
        getCultureForLoggedInUser: getCultureForLoggedInUser,
        getCultureForLoggedInUserAsync: getCultureForLoggedInUserAsync,
        getUserCulture: getUserCulture,
        getAfterpayLocaleInfo: getAfterpayLocaleInfo,
        setupCultureForLoggedInUser: setupCultureForLoggedInUser,
        setCulture: setCulture,
        getDefaultLanguageCode: getDefaultLanguageCode,
        needCachedDataFromServer: needCachedDataFromServer,
        getDateFormat: getDateFormat,
        getPhoneFormat: getPhoneFormat,
    };
    //#endregion

}();

//#region   Validation object to append to idstc object
idstc.prototype.validation = {

    getCreditCardType: function (number) {
        var card, card_type, card_types, get_card_type;

        //#region Card_Types array
        card_types = [
            {
                id: '3',
                name: 'AmericanExpress',
                pattern: /^3[47]/,
                valid_length: [15]
            }, {
                id: '1',
                name: 'Visa',
                pattern: /^4/,
                valid_length: [16]
            }, {
                id: '2',
                name: 'MasterCard',
                pattern: /^5[1-5]/,
                valid_length: [16]
            }, {
                id: '4',
                name: 'Discover',
                pattern: /^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)/,
                valid_length: [16]
            }
        ];
        //#endregion

        var options = {};

        get_card_type = function (number) {
            var _j, _len1, _ref2;
            _ref2 = (function () {
                var _k, _len1, _ref2, _results;
                _results = [];
                for (_k = 0, _len1 = card_types.length; _k < _len1; _k++) {
                    card = card_types[_k];
                    if (_ref2 = card.name) {
                        _results.push(card);
                    }
                }
                return _results;
            })();
            for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
                card_type = _ref2[_j];
                if (number.match(card_type.pattern)) {
                    return card_type;
                }
            }
            return null;
        };

        return get_card_type(number);
    }

};
//#endregion

//#region   Clipboard Copy
idstc.prototype.clipboard = (function (window, document, navigator) {
    var textArea, copy;

    function isOS() {
        return navigator.userAgent.match(/ipad|iphone/i);
    }

    function createTextArea(text) {
        textArea = document.createElement('textArea');
        textArea.value = text;
        textArea.style.position = 'fixed'; // Prevent scrolling to bottom on iOS
        textArea.style.opacity = '0';
        document.body.appendChild(textArea);
    }

    function selectText() {
        var range, selection;
        if (isOS()) {
            range = document.createRange();
            range.selectNodeContents(textArea);
            selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            textArea.setSelectionRange(0, 999999);
        }
        else {
            textArea.select();
        }
    }

    function legacyCopy() {
        try {
            document.execCommand('copy');
        } catch (err) {
            console.warn('Fallback copy failed:', err);
        }
        document.body.removeChild(textArea);
    }

    function copy(text) {
        // Try modern Clipboard API first
        if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
            navigator.clipboard.writeText(text).catch(function () {
                // Fallback if Clipboard API fails
                createTextArea(text);
                selectText();
                legacyCopy();
            });
        } else {
            // Fallback for older browsers
            createTextArea(text);
            selectText();
            legacyCopy();
        }
    }

    return { copy: copy };

})(window, document, navigator);

//endregion
//#region Izenda Report

//this function will post the parameter values and redirect the user to display the report
function postRedirectIzenda(url, args) {
    var form = $('<form target="_blank" action="' + url + '" method="post">' +
        '<input type="text" name="args" value="' + args + '" />' +
        '</form>');
    $('body').append(form);
    form.submit();
}

window.downloadFileFromStream = async (fileName, contentStreamReference) => {
    const arrayBuffer = await contentStreamReference.arrayBuffer();
    const blob = new Blob([arrayBuffer]);
    const url = URL.createObjectURL(blob);
    const anchorElement = document.createElement('a');
    anchorElement.href = url;
    anchorElement.download = fileName;
    anchorElement.click();
    anchorElement.remove();
    URL.revokeObjectURL(url);
}

window.goBack = function () {
    window.history.back();
}

window.loadScriptOnce = function (src) {
    return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src="${src}"]`)) {
            resolve();
            return;
        }

        const script = document.createElement('script');
        script.src = src;
        script.onload = () => resolve();
        script.onerror = () => reject(new Error(`Failed to load ${src}`));
        document.head.appendChild(script);
    });
};

window.setCurrencyFormatter = function (dotNetHelper) {
    window.formatCurrencyFromBlazor = function (value, culture, symbol) {
        const result = dotNetHelper.invokeMethod("formatCurrencyBlazor", value, culture, symbol);
        return result;
    };
};

//#endregion

// ============================================================================
// Nav refresh — shared behavior (both stacks). Uses document-level event
// delegation throughout because the Blazor stack renders the sidebar AFTER
// WASM boot (nothing exists at DOMContentLoaded) and the Angular stack builds
// the menu asynchronously.
//
// Adds three behaviors on top of the existing nav-large/nav-small toggle:
//   1. Mobile drawer  (<992px): hamburger opens the sidebar over a scrim,
//      closes on scrim tap / Esc / menu navigation.
//   2. Rail flyouts   (nav-small, >=992px): hovering a collapsed group shows
//      its children in a .nav-flyout panel; leaves show their label as a link.
//   3. Search hotkey  Cmd/Ctrl+K focuses the menu search input.
// ============================================================================
(function () {
    "use strict";

    var DRAWER_BP = 992; // keep in sync with @nav-drawer-bp / $nav-drawer-bp
    var GROUP_TOGGLE = '[data-toggle="collapse"], [data-bs-toggle="collapse"]';

    function enabled() { return !!document.body; }
    function isMobile() { return window.innerWidth < DRAWER_BP; }
    function sidebar() { return document.getElementById("page-sidebar-wrapper"); }

    // ---- 1. mobile drawer ------------------------------------------------------
    var scrim = null;

    function ensureScrim() {
        if (scrim || !document.body) return;
        scrim = document.createElement("div");
        scrim.className = "nav-scrim";
        scrim.addEventListener("click", closeDrawer);
        document.body.appendChild(scrim);
    }

    function ensureCloseButton() {
        var nav = sidebar();
        if (!nav || nav.querySelector(".nav-drawer-close")) return;
        var btn = document.createElement("button");
        btn.type = "button";
        btn.className = "nav-drawer-close";
        btn.setAttribute("aria-label", "Close menu");
        btn.innerHTML = "&times;";
        btn.addEventListener("click", closeDrawer);
        nav.appendChild(btn);
    }

    function openDrawer() {
        ensureScrim();
        ensureCloseButton();
        document.body.classList.add("nav-drawer-open");
    }
    function closeDrawer() { document.body.classList.remove("nav-drawer-open"); }

    // capture phase so this runs before the legacy jQuery toggle handler
    document.addEventListener("click", function (e) {
        if (!enabled()) return;

        // hamburger: on mobile widths it drives the drawer instead of nav-small
        var toggle = e.target.closest && e.target.closest(".nav-menu-toggle-button");
        if (toggle && isMobile()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            document.body.classList.contains("nav-drawer-open") ? closeDrawer() : openDrawer();
            return;
        }

        // navigating from inside the open drawer closes it; group toggles are
        // anchors too, so exempt them or expanding a submenu closes the menu
        if (isMobile() && document.body.classList.contains("nav-drawer-open")) {
            var nav = sidebar();
            if (nav && nav.contains(e.target) && e.target.closest("a[href]")
                && !e.target.closest(GROUP_TOGGLE)) closeDrawer();
        }
    }, true);

    window.addEventListener("resize", function () {
        if (!isMobile()) closeDrawer();
    });

    // ---- 2. rail flyouts ---------------------------------------------------------
    // Hover-intent design: moving diagonally from a rail icon to a lower item
    // in its (tall) flyout sweeps across neighboring icons. Switching flyouts
    // on first touch made the panel vanish mid-path, so switching to a
    // neighbor's flyout is DELAYED and cancelled if the cursor reaches the
    // open flyout first. Kills are grace-timed and re-checked against :hover
    // ground truth so a flyout under the cursor is never removed.
    var flyout = null, flyTimer = null, swapTimer = null, hoverPanel = null;
    var openTimer = null, openPanel = null;
    var FLYOUT_OPEN_DELAY = 180; // so brushing past the rail doesn't flash panels

    function railActive() {
        var pw = document.getElementById("page-wrapper");
        return enabled() && !isMobile() && pw && pw.classList.contains("nav-small");
    }

    // touch devices can't hover, so the rail is driven by taps instead.
    // Queried once; .matches stays live if a pointer is attached or detached.
    var hoverMq = window.matchMedia ? window.matchMedia("(hover: hover)") : null;
    function hasHover() {
        return !hoverMq || hoverMq.matches;
    }

    function cancelSwap() { clearTimeout(swapTimer); swapTimer = null; }

    function cancelOpen() { clearTimeout(openTimer); openTimer = null; openPanel = null; }

    // first hover on the rail waits out FLYOUT_OPEN_DELAY; cancelled if the
    // cursor has moved off the icon by the time it fires
    function scheduleOpen(panel) {
        if (openPanel === panel) return;
        cancelOpen();
        openPanel = panel;
        openTimer = setTimeout(function () {
            openTimer = null;
            openPanel = null;
            if (!railActive() || flyout || !panel.matches(":hover")) return;
            showFlyout(panel, sidebar());
        }, FLYOUT_OPEN_DELAY);
    }

    function killFlyout() {
        if (flyout) { flyout.remove(); flyout = null; }
        clearTimeout(flyTimer);
        cancelSwap();
        cancelOpen();
    }

    function pointerIsSafe() {
        // true while the cursor rests on the open flyout or its source icon
        return !!(flyout && (flyout.matches(":hover") ||
            (flyout._for && flyout._for.matches(":hover"))));
    }

    function scheduleKill() {
        if (!hasHover()) return; // touch: only a tap elsewhere closes the flyout
        clearTimeout(flyTimer);
        flyTimer = setTimeout(function () {
            if (pointerIsSafe()) { scheduleKill(); return; }
            killFlyout();
        }, 400);
    }

    // a flyout row mirrors a real nav anchor, so forward plain clicks to it and let
    // the source's own handlers run (Angular guards leaf links against dirty forms)
    function makeFlyoutLink(source) {
        var link = document.createElement("a");
        link.href = source.getAttribute("href") || "#";
        if (source.target) link.target = source.target;
        link.textContent = source.textContent.trim();
        // group rows only toggle a collapse the rail keeps hidden: leave them as-is
        if (source.closest(GROUP_TOGGLE)) return link;
        link.addEventListener("click", function (e) {
            if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return; // keep open-in-new-tab
            e.preventDefault();
            source.click();
        });
        return link;
    }

    function showFlyout(panel, nav) {
        killFlyout();

        flyout = document.createElement("div");
        flyout.className = "nav-flyout";
        flyout._for = panel;

        var heading = panel.querySelector(".panel-heading a, a.list-group-item");
        var children = panel.querySelectorAll(".panel-collapse a, .collapse a, .collapsing a");
        if (children.length) {
            children.forEach(function (a) {
                flyout.appendChild(makeFlyoutLink(a));
            });
        } else if (heading) {
            // leaf: the label is a link too, so clicking the name navigates like the icon
            flyout.appendChild(makeFlyoutLink(heading));
        } else {
            flyout = null;
            return;
        }

        document.body.appendChild(flyout);
        var rect = panel.getBoundingClientRect();
        var navRect = nav.getBoundingClientRect();
        flyout.style.left = (navRect.right + 6) + "px";
        flyout.style.top = Math.max(8, Math.min(rect.top, window.innerHeight - flyout.offsetHeight - 8)) + "px";

        flyout.addEventListener("mouseleave", scheduleKill);
        // selecting a link closes the flyout (Blazor navigations don't reload)
        flyout.addEventListener("click", function (e) {
            if (e.target.closest("a")) killFlyout();
        });
    }

    document.addEventListener("mouseover", function (e) {
        if (!railActive() || !hasHover() || !e.target.closest) return;
        var nav = sidebar();
        if (!nav) return;

        // cursor is on the flyout (incl. its gap bridge): nothing may kill or swap it
        if (flyout && flyout.contains(e.target)) {
            clearTimeout(flyTimer);
            cancelSwap();
            cancelOpen();
            return;
        }

        var panel = e.target.closest(".panel");
        if (!panel || !nav.contains(panel)) {
            cancelOpen();
            if (flyout && !nav.contains(e.target)) scheduleKill();
            return;
        }

        hoverPanel = panel;
        clearTimeout(flyTimer); // over a rail icon: not leaving

        if (!flyout) { scheduleOpen(panel); return; }
        if (flyout._for === panel) { cancelSwap(); return; }

        // different icon while a flyout is open: swap only after the cursor
        // has settled there — a diagonal path to the flyout cancels this
        if (!swapTimer) {
            swapTimer = setTimeout(function () {
                swapTimer = null;
                if (!railActive() || !flyout) return;
                if (flyout.matches(":hover")) return; // reached the flyout: keep it
                if (hoverPanel && hoverPanel.matches(":hover") && flyout._for !== hoverPanel) {
                    showFlyout(hoverPanel, sidebar());
                }
            }, 220);
        }
    }, true);

    document.addEventListener("mouseout", function (e) {
        if (!railActive() || !hasHover() || !e.target.closest) return;
        var nav = sidebar();
        if (!nav || !nav.contains(e.target)) return;
        if (openPanel && !openPanel.contains(e.relatedTarget)) cancelOpen();
        if (flyout) scheduleKill();
    }, true);

    // rail toggled back to full width: drop any open flyout
    document.addEventListener("click", function (e) {
        if (enabled() && e.target.closest && e.target.closest(".nav-menu-toggle")) killFlyout();
    });

    // ---- 2b. rail: clicking a group opens its flyout ----------------------------
    // Expanding the accordion inside a 68px rail shows unlabeled icons, so the
    // click pops the children out in the flyout instead. On touch that is the only
    // way to reach them at all, since there is no hover.
    // Bound on WINDOW capture, not document: the collapse data-api delegates off
    // document, so window capture is the one place guaranteed to run before it
    // regardless of which Bootstrap build is loaded.
    window.addEventListener("click", function (e) {
        if (!railActive() || !e.target || !e.target.closest) return;

        var toggle = e.target.closest(GROUP_TOGGLE);
        var nav = sidebar();
        if (!toggle || !nav || !nav.contains(toggle)) return;

        var panel = toggle.closest(".panel");
        if (!panel) return;

        // keyboard activation keeps the in-place accordion: the flyout is appended
        // at body end, so its children would sit outside the tab order
        if (e.detail === 0) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        if (flyout && flyout._for === panel) {
            if (!hasHover()) killFlyout(); // tapping the open group closes it
            return; // with hover: leave open, the pointer is still on it
        }

        killFlyout();
        showFlyout(panel, nav);
    }, true);

    // clicking anywhere off the flyout closes it — the only dismissal on touch,
    // where there is no mouseleave to hang the kill timer off. Group toggles never
    // reach here (the window handler above stops them), so no sidebar exemption:
    // a leaf-link tap must dismiss an open flyout rather than leave it pinned.
    document.addEventListener("click", function (e) {
        if (!flyout || !e.target.closest) return;
        if (flyout.contains(e.target)) return;
        killFlyout();
    });

    // rail: the search input is display:none, so it must be un-collapsed first
    function expandRailToSearch() {
        var toggle = document.querySelector(".header-bar .nav-menu-toggle-button");
        if (toggle) toggle.click();
        setTimeout(function () {
            var nav = sidebar();
            var input = nav && nav.querySelector(".nav-search-wrapper input");
            if (input) input.focus();
        }, 300); // after the width transition has mostly settled
    }

    // rail: clicking the boxed search icon expands the menu and focuses search
    document.addEventListener("click", function (e) {
        if (!railActive() || !e.target.closest) return;
        var icon = e.target.closest(".nav-search-icon");
        var nav = sidebar();
        if (!icon || !nav || !nav.contains(icon)) return;
        expandRailToSearch();
    });

    // stamp the platform hotkey hint on the search field; the stylesheet
    // renders it via .nav-search-wrapper::after { content: attr(data-kbd) }.
    // Poll briefly because both stacks render the sidebar asynchronously.
    var kbdTimer = setInterval(function () {
        var w = document.querySelector(".nav-search-wrapper");
        if (w) {
            w.setAttribute("data-kbd", /Mac|iP/.test(navigator.platform) ? "⌘K" : "Ctrl+K");
            clearInterval(kbdTimer);
        }
    }, 400);
    setTimeout(function () { clearInterval(kbdTimer); }, 20000);

    // ---- 3. keyboard -----------------------------------------------------------
    document.addEventListener("keydown", function (e) {
        if (!enabled()) return;

        if (e.key === "Escape") { closeDrawer(); killFlyout(); return; }

        if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
            var nav = sidebar();
            var input = nav && nav.querySelector(".nav-search-wrapper input");
            if (input) {
                e.preventDefault();
                // collapsed nav hides the input, so open it before focusing
                if (railActive()) { expandRailToSearch(); return; }
                if (isMobile()) openDrawer();
                input.focus();
            }
        }
    });

    // ---- 3b. expanded menu: tabbing onto a group opens its children --------------
    // Parent rows are now focusable, so Tab reaches them. Landing on one BY KEYBOARD
    // expands it, putting its children in the tab order. Mouse focus must not expand:
    // focusin fires before click, so expanding here would let the click collapse it
    // again and clicking a group would appear to do nothing.
    var kbNav = false;
    document.addEventListener("keydown", function (e) { if (e.key === "Tab") kbNav = true; }, true);
    document.addEventListener("pointerdown", function () { kbNav = false; }, true);

    // BS3 puts the collapse target in href, BS5 in data-bs-target
    function collapseTargetFor(el) {
        var sel = el.getAttribute("data-bs-target") || el.getAttribute("data-target");
        if (!sel) {
            var href = el.getAttribute("href") || "";
            var hash = href.indexOf("#");
            if (hash >= 0) sel = href.slice(hash);
        }
        if (!sel || sel === "#") return null;
        try { return document.querySelector(sel); } catch (err) { return null; }
    }

    function isExpanded(panel) {
        return !!panel && (panel.classList.contains("in") || panel.classList.contains("show"));
    }

    document.addEventListener("focusin", function (e) {
        if (!enabled() || railActive() || !kbNav || !e.target.closest) return;
        var nav = sidebar();
        if (!nav || !nav.contains(e.target)) return;

        var toggle = e.target.closest(GROUP_TOGGLE);
        if (!toggle || !nav.contains(toggle)) return;

        var panel = collapseTargetFor(toggle);
        if (!panel || isExpanded(panel)) return;

        toggle.click(); // let whichever Bootstrap is loaded do the expanding
    });

    // Enter/Space on a group row. The Blazor heading is a div, which does NOT
    // synthesize a click the way a real button does, and Bootstrap collapse only
    // listens for click — so without this, role="button" lies and groups can be
    // opened by focus but never closed. Native controls (<button>, <a href>, as the
    // MVC menu builds) fire their own click, so skip those or we'd toggle twice.
    // In the rail the synthesized click carries detail 0, which the handler in 2b
    // routes to the in-place accordion.
    document.addEventListener("keydown", function (e) {
        if (!enabled() || !e.target.closest) return;
        if (e.key !== "Enter" && e.key !== " " && e.key !== "Spacebar") return;

        var nav = sidebar();
        if (!nav || !nav.contains(e.target)) return;

        var toggle = e.target.closest(GROUP_TOGGLE);
        if (!toggle || !nav.contains(toggle)) return;
        if (toggle.tagName === "BUTTON" || (toggle.tagName === "A" && toggle.hasAttribute("href"))) return;

        e.preventDefault(); // Space would scroll the page
        toggle.click();
    });

    // ---- 4. skip link ----------------------------------------------------------
    // Angular claims href="#..." clicks via $location, so the native fragment jump
    // never lands. Move focus ourselves. Not gated on enabled(): the link ships in
    // both layouts regardless of the nav-refresh flag. Enter on a link fires click,
    // so this covers keyboard activation too.
    document.addEventListener("click", function (e) {
        var link = e.target.closest && e.target.closest(".skip-link");
        if (!link) return;

        var id = (link.getAttribute("href") || "").replace(/^#/, "");
        var target = id && document.getElementById(id);
        if (!target) return;

        e.preventDefault();
        // a div can't take focus without this; Blazor renders the wrapper itself
        // so don't rely on the markup carrying it
        if (!target.hasAttribute("tabindex")) target.setAttribute("tabindex", "-1");
        target.focus();
        target.scrollIntoView();
    });

    // ---- sticky header: condense once scrolled -------------------------------
    // Condensing shrinks the sticky header (and so the document) by ~32px, so a
    // single threshold right at the top would flap when the page is barely
    // taller than the viewport — condense only past the height delta, expand
    // near the very top.
    var condensed = false;

    function syncCondensed() {
        var y = window.pageYOffset || document.documentElement.scrollTop || 0;
        var next = condensed ? y > 8 : y > 48;
        if (next !== condensed) {
            condensed = next;
            document.body.classList.toggle("nav-condensed", condensed);
        }
    }

    window.addEventListener("scroll", syncCondensed, { passive: true });
    document.addEventListener("DOMContentLoaded", syncCondensed); // reloads mid-page

    // ---- phone header: "more" toggle for the action chips --------------------
    // The stylesheet hides .header-actions below the actions breakpoint; this
    // expands the header into two rows (chips on the second) and back.
    document.addEventListener("click", function (e) {
        if (!enabled() || !e.target.closest) return;
        var btn = e.target.closest(".header-actions-toggle");
        if (!btn) return;
        e.preventDefault();
        var bar = btn.closest(".header-bar");
        if (!bar) return;
        var open = bar.classList.toggle("header-actions-open");
        btn.setAttribute("aria-expanded", open ? "true" : "false");
    });
})();

// ---- culture body classes -------------------------------------------------
// Stamps lang-xx / country-xx / culture-xx-xx on <body> so CSS can target
// the user's country/language.
(function () {
    function getCultureCode() {
        // same lookup order as getAfterpayLocaleInfo
        try {
            var raw = localStorage.getItem('Culture');
            if (raw) {
                if (raw.trim().charAt(0) === '{') {
                    var parsed = JSON.parse(raw);
                    if (parsed && parsed.culture) return parsed.culture;
                } else {
                    return raw;
                }
            }
        } catch (e) { }
        try {
            return sessionStorage.getItem('culture') || '';
        } catch (e) { }
        return '';
    }

    function apply() {
        var body = document.body;
        if (!body) return;

        var match = String(getCultureCode()).trim().match(/^([A-Za-z]{2,3})(?:-([A-Za-z]{2,3}))?$/);
        if (!match) return;

        var lang = match[1].toLowerCase();
        var country = match[2] ? match[2].toLowerCase() : '';

        // drop previously stamped classes so a mid-session culture change doesn't stack codes
        body.className = body.className.replace(/(^|\s)(lang|country|culture)-[a-z0-9-]+/g, '').trim();

        body.classList.add('lang-' + lang);
        if (country) {
            body.classList.add('country-' + country);
            body.classList.add('culture-' + lang + '-' + country);
        }

        // enables :lang() CSS and helps screen readers
        document.documentElement.lang = match[0];
    }

    apply();
    // in _Host the bundle loads in <head>, and the culture may be fetched async on first login
    document.addEventListener('DOMContentLoaded', apply);
    window.addEventListener('load', apply);
    // called by setCulture when the culture changes
    window.applyCultureBodyClasses = apply;
})();
